import React, { Suspense, useEffect, useRef } from 'react'
import { RouterProvider, createBrowserRouter, useLocation, useNavigationType } from 'react-router-dom'
import AuthLayout from './layout/AuthLayout';
import LoginPage from './login-page/LoginPage';
import ResultPage from './2d-game/ResultPage';
import ResultPage2d from './2d-game/ResultPage2d';
import ResultPage1d from './2d-game/ResultPage1d';
import ResultPage3d from './2d-game/ResultPage3d';
import ResultPageTitli from './2d-game/ResultPageTitli.js';
import Layout from './2d-game/Layout';
import ErrorPage from './error-page/ErrorPage';
import ReportModal2d from './2d-game/modals/report-modal/ReportModal2d';
import ClaimTicketModal2d from './2d-game/modals/claim-ticket/ClaimTicketModal2d';
import ClaimTicketModal1d from './1d-game/modals/claim-ticket/ClaimTicketModal2d';
import ReprintModal from './2d-game/modals/reprint-modal/ReprintModal';
import ReprintModal1d from './1d-game/modals/reprint-modal/ReprintModal';
import ReprintLIst from './2d-game/modals/reprint-modal/ReprintLIst';
import ReprintLIst1d from './1d-game/modals/reprint-modal/ReprintLIst';
import LayoutCreateUser from './create-user/LayoutCreateUser.js';
import LayoutReportUser from './create-user/LayoutReportUser.js';
import LayoutBalanceTransfer from './create-user/LayoutBalanceTransfer.js';

import ReprintModalTitli from './Titli-game/modals/reprint-modal/ReprintModalTitli';
import ReprintLIstTitli from './Titli-game/modals/reprint-modal/ReprintLIstTitli';
import CancelCouponTitli from './Titli-game/component/common/CancelCoupon.js';

import AutoResult from './2d-game/modals/auto-result/AutoResult';
import ResetPasswordModal from './2d-game/modals/reset-password-modal/ResetPasswordModal';
import Layout3d from './3d-game/Layout3d';
import Layout1d from './1d-game/Layout1d.js';
import AccountPopup3d from './3d-game/component/common/AccountPopup3d.js';
import ReprintPopUp3d from './3d-game/component/common/RePrintPopup3d.js';
import PrintPage3d from './3d-game/component/common/PtintPage3d.js';
import CancelCoupon from './3d-game/component/common/CancelCoupon.js';
import ResultPopup3d from './3d-game/component/common/ResultPopup3d.js';
import ResultPopupTitli from './Titli-game/componenent/common/ResultPopupTitli.js';
import AdvanceDrawPopup3d from './3d-game/component/common/AdvanceDrawPopup3d.js';
import ClaimTicketModal3d from './3d-game/component/claim-ticket/ClaimTicketModal3d.js';
import { SocketState } from './context/SocketProvider.js';
import WinnerPopup from './comonComponent/winner-looser/WinnerPopup.js';
import LayoutTitli from './Titli-game/LayoutTitli';
import AdvanceDrawTitliModal from './Titli-game/modals/advance-draw/AdvanceDrawModal.js';   
import AdvanceDrawModal1d from './1d-game/modals/advance-draw/AdvanceDrawModal.js';
import ClaimTicketModalTitli from './Titli-game/component/common/ClaimTicketModalTitli.js';

const AuthGuard = React.lazy(() => import('./AuthGuard.js'));
const ResultModal2d = React.lazy(() => import('./2d-game/modals/result-modal/ResultModal2d'));
const ResultModal1d = React.lazy(() => import('./1d-game/modals/result-modal/ResultModal1d'));
const ComplaintModal2d = React.lazy(() => import('./2d-game/modals/complaint-modal/ComplaintModal2d'));
const AdvanceDrawModal = React.lazy(() => import('./2d-game/modals/advance-draw/AdvanceDrawModal'));
const CancelTicketModal2d = React.lazy(() => import('./2d-game/modals/cancel-ticket/CancelTicketModal2d'));
const CancelTicketModal1d = React.lazy(() => import('./1d-game/modals/cancel-ticket/CancelTicketModal1d'));

function RouteWatcher() {
    const location = useLocation();
    const navigationType = useNavigationType();
    const prevPathRef = useRef(location.pathname);
    const { socket } = SocketState(); // Get socket from context

    useEffect(() => {
        const currentPath = location.pathname;
        const prevPath = prevPathRef.current;

        // Check if navigation was done using browser back/forward buttons
        const isBrowserNavigation = navigationType === 'POP';

        // Check if current route is exactly /2d or /3d (not subroutes)
        const isMainRoute = currentPath === '/2d' || currentPath === '/3d';

        // Check if we're coming from a different main route
        const isRouteChange = (prevPath === '/2d' && currentPath === '/3d') ||
            (prevPath === '/3d' && currentPath === '/2d');

        if (isBrowserNavigation && isMainRoute && isRouteChange && socket) {
            // Emit the same socket event as your onClick handlers
            socket.emit('req', {
                en: "LOTTARY_CLOSE_GAME",
                data: {}
            });

            // console.log('Socket event emitted for browser navigation between routes');
        }

        // Update game route in localStorage
        let gameRoute = null;
        if (currentPath.includes("2d")) {
            gameRoute = "2d";
        } else if (currentPath.includes("3d")) {
            gameRoute = "3d";
        }

        if (gameRoute) {
            localStorage.setItem("gameRoute", gameRoute);
        }

        prevPathRef.current = currentPath;
    }, [location, navigationType, socket]);

    return null;
}

const router = createBrowserRouter([

    {
        path: "",
        element: (
            <>
                <RouteWatcher /> {/* 👈 must live inside router */}
                <AuthLayout />
            </>
        ),
        children: [
            {
                path: "/2d",
                element: <AuthGuard component={<Layout />} />,
                children: [
                    {
                        path: "resultModal2d",
                        element: <ResultModal2d />,
                    },
                    {
                        path: "complaintModal2d",
                        element: <ComplaintModal2d />,
                    },
                    {
                        path: "advance",
                        element: <AdvanceDrawModal />,
                    },
                    {
                        path: "report",
                        // element: <ReportModal2d />,
                        element: <AccountPopup3d />,
                    },
                    {
                        path: "claim-ticket",
                        element: <ClaimTicketModal2d />,
                    },
                    {
                        path: "reprint",
                        element: <ReprintModal />,
                    },
                    {
                        path: "reprint/list",
                        element: <ReprintLIst />,
                    },
                    {
                        path: "cancel-ticket",
                        element: <CancelTicketModal2d />,
                    },
                    {
                        path: "auto-result",
                        element: <AutoResult />,
                    },
                    {
                        path: "win-lose-result",
                        element: <WinnerPopup />,
                    },
                    {
                        path: "secure",
                        element: <ResetPasswordModal />,
                    },
                ]
            },
            {
                path: "/3d",
                // element: <AuthGuard component={<Layout3d />} />,
                element: <Layout3d />,
                children: [
                    {
                        path: "account",
                        element: <AccountPopup3d />,
                    },
                    {
                        path: "reprint",
                        element: <ReprintPopUp3d />,
                        // children: [
                        //     {
                        //         path: ":time",
                        //         element: <PrintPage3d />,
                        //     },
                        // ]
                    },
                    {
                        path: "reprint/list",
                        element: <PrintPage3d />,
                    },
                    {
                        path: "cancelCoupon",
                        element: <CancelCoupon />,
                    },
                    {
                        path: "result",
                        element: <ResultPopup3d />,
                    },
                    {
                        path: "advance",
                        element: <AdvanceDrawPopup3d />,
                    },
                    {
                        path: "claim-ticket-3d",
                        element: <ClaimTicketModal3d />,
                    },
                    {
                        path: "win-lose-result",
                        element: <WinnerPopup />,
                    },
                ]
            },
            {
                path: "/titli",
                // element: <AuthGuard component={<Layout3d />} />,
                element: <LayoutTitli key={window.location.pathname} />,
                children: [
                    {
                        path: "account",
                        element: <AccountPopup3d />,
                    },
                    {
                        path: "reprint",
                        element: <ReprintModalTitli />,
                    },
                    {
                        path: "reprint/list",
                        element: <ReprintLIstTitli />,
                    },
                    {
                        path: "cancelCoupon",
                        element: <CancelCouponTitli />,
                    },
                    {
                        path: "result",
                        element: <ResultPopupTitli />,
                    },
                    {
                        path: "advance",
                        element: <AdvanceDrawTitliModal />,
                    },
                    {
                        path: "claim-ticket-titli",
                        element: <ClaimTicketModalTitli />,
                    },
                    {
                        path: "win-lose-result",
                        element: <WinnerPopup />,
                    },
                ]
            },
            {
                path: "/1d",
                // element: <AuthGuard component={<Layout3d />} />,
                element: <Layout1d key={window.location.pathname} />,
                children: [{
                        path: "ResultModal1d",
                        element: <ResultModal1d />,
                    },
                    {
                        path: "complaintModal2d",
                        element: <ComplaintModal2d />,
                    },
                    {
                        path: "advance",
                        element: <AdvanceDrawModal1d />,
                    },
                    {
                        path: "report",
                        // element: <ReportModal2d />,
                        element: <AccountPopup3d />,
                    },

                    {
                        path: "claim-ticket",
                        element: <ClaimTicketModal1d />,
                    },
                    {
                        path: "reprint1d",
                        element: <ReprintModal1d />,
                    },
                    {
                        path: "reprint1d/list",
                        element: <ReprintLIst1d />,
                    },
                    {
                        path: "cancel-ticket-1d",
                        element: <CancelTicketModal1d />,
                    },
                    {
                        path: "auto-result",
                        element: <AutoResult />,
                    },
                    {
                        path: "win-lose-result",
                        element: <WinnerPopup />,
                    },
                    {
                        path: "secure",
                        element: <ResetPasswordModal />,
                    },
                ]
            },
            {
                path: "/createUser",
                element: <LayoutCreateUser />,
            },  
            {
                path: "/reportUser",
                element: <LayoutReportUser />,
            },
            {
                path: "/balance-transfer",
                element: <LayoutBalanceTransfer />,
            },

            {
                path: "/login",
                element: <LoginPage />,
                errorElement: <ErrorPage />,
                children: [
                    {
                        path: "resultModal2d",
                        element: <ResultModal2d />,
                    }
                ]
            },
        ]

    },


    {
        path: "/result",
        element: <ResultPage />,
    },

    {
        path: "/result3d",
        element: <ResultPage3d />,
    },
    {
        path: "/result2d",
        element: <ResultPage2d />,
    },
    {
        path: "/resultTitli",
        element: <ResultPageTitli />,
    },
    {
        path: "/result1d",
        element: <ResultPage1d />,
    },
    // {N
])

function Routing() {
    return (
        <Suspense fallback={<div>Loading..</div>}>
            <RouterProvider router={router} />
        </Suspense>
    )
}

export default Routing